import { createFileRoute } from '@tanstack/react-router'

import { DigitalProductPrizes } from '@/features/prizes'
import {
  validatePrizeSheetSearch,
  type PrizeSheetSearch
} from '@/features/prizes/lib/prizeSheetSearch'

export const Route = createFileRoute('/_event/sorteios')({
  validateSearch: (search: Record<string, unknown>): PrizeSheetSearch =>
    validatePrizeSheetSearch(search),
  component: DigitalProductPrizesPage
})

function DigitalProductPrizesPage() {
  const sheetSearch = Route.useSearch()

  return <DigitalProductPrizes sheetSearch={sheetSearch} />
}
